<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="full-control">
            <div class="list">
              <md-list>
                <!-- Geotêxtil -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/geotextil1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo">Geotêxtil</span>
                    <span class="md-subhead spanSubTitulo">(não-tecido)</span>
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Geotêxtil (não-tecido)</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        O geotêxtil não-tecido, é de alta qualidade composto por
                        filamentos entrelaçados, interligados pelo processo de
                        agulhagem. Apresenta excelentes características técnicas
                        e elevadas resistências a degradação química e
                        biológica.
                      </p>
                      <p class="paragrafo">
                        Devido à sua alta permeabilidade, o geotêxtil não-tecido
                        permite a passagem de fluidos através de sua estrutura,
                        retendo as partículas de solo, substituindo os
                        tradicionais filtros granulométricos. Sua gramatura,
                        espessura e resistência ao puncionamento permite que o
                        geotêxtil não-tecido atue como elemento de separação
                        entre os solos, com características diferentes evitando
                        que eles se misturam.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Em contato com
                            geomembranas, o geotêxtil não-tecido oferece ótima
                            proteção contra esforços localizados, gerado pelo
                            lançamento de resíduos
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> O geotêxtil
                            não-tecido também pode ser aplicado em
                            repavimentação de ruas e rodovias, pois impregnado
                            com betume, forma uma membrana viscoelástica que
                            retarda a reflexão de trincas e evita a infiltração
                            de água.
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Devido a todas
                            estas características o geotêxtil não-tecido pode
                            ser empregado em drenagem, aterros sanitários e na
                            repavimentação de estradas e rodovias.
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          style="margin-left: 20%; margin-top: 50px"
                          src="../assets/produtos/geotextil2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Características</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Resistência a
                            degradação
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Alta
                            Permeabilidade
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Elevada
                            resistência a tração
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Alto teor de
                            absorção de asfalto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Disponível em
                            poliéster e polipropileno
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Específicações Técnicas</h3>
                        <h5>Geotextil (não tecido)</h5>
                      </v-col>
                      <v-col cols="12">
                        <img
                          src="../assets/produtos/geotextilEspecificacoes.png"
                        />
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Tubo Dreno CenterGeo -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/tuboDreno1.jpg"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo">Tubo Dreno</span>
                    <span class="md-subhead spanSubTitulo">CenterGeo</span>
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Tubo Dreno</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <h3 style="margin-top: -15px">CenterGeo</h3>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Tubo fabricado em PEAD (polietileno de alta densidade)
                        com secção anelar, perfurado, corrugado e dentro da
                        norma ABNT NBR 15.073. Com sua flexibilidade,
                        resistência e alta capacidade drenante, faz a captação e
                        escoamento de líquidos em excesso, destinado a drenagem
                        geral.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Rodovias,
                            ferrovias
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Obras de
                            contenção
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Campos
                            esportivos: futebol, tênis, golfe
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Aterros
                            sanitários
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Estacionamentos
                            e pátios
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Aeroportos
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Dessalinização
                            de solos em agricultura
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Drenagem
                            agrícola
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Rebaixamento de
                            lençol freático
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Barragens
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Áreas verdes
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          style="margin-top: 50px"
                          src="../assets/produtos/tuboDreno2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Acessórios</h3>
                      </v-col>
                      <v-col cols="9">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Camisa drenante
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Fabricada a
                            partir de geotêxtil não-tecido, a camisa drenante é
                            utilizada para revestir o tubo dreno, atuando como
                            elemento separador e filtrante, garantindo
                            eficiência e longevidade nos mais diversos sistemas
                            de drenagem.
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Conexões e
                            Tampão
                          </li>
                          <img
                            class="imagem-produto-acessorios"
                            id="prodTudoDrenoAcess"
                            src="../assets/produtos/tuboDrenoAcessorio3.png"
                          />
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          class="imagem-produto-acessorios"
                          style="width: 100px"
                          src="../assets/produtos/tuboDrenoAcessorio1.png"
                        />
                        <img
                          class="imagem-produto-acessorios"
                          style="width: 100px"
                          src="../assets/produtos/tuboDrenoAcessorio2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Específicações Técnicas</h3>
                        <h4>Tubo Dreno CenterGeo</h4>
                      </v-col>
                      <v-col cols="12">
                        <img
                          src="../assets/produtos/tuboDrenoEspecificacoes2.png"
                        />
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Eletroduto -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/eletroduto1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo">Eletroduto</span>
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Eletroduto</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Duto fabricado em PEAD (Polietileno de Alta Densidade)
                        com secção anelar (corrugado) e cabo guia. Atende as
                        normas IEC 61386-24, EN 50086-2-4:1994 e a norma ABNT
                        NBR 15715.
                      </p>
                      <p class="paragrafo">
                        É utilizado na proteção de cabeamentos elétricos, TV
                        cabo, telecomunicações, instalações de manutenção, entre
                        outros.
                      </p>
                      <p class="paragrafo">
                        Possui baixo coeficiente de atrito e alta resistência a
                        agressões físicas.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Aeroportos,
                            portos, ferrovias e rodovias
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Condomínios
                            Residenciais e Indústrias
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Telefonia e
                            Subduto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Iluminação
                            pública
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Sinalização
                            urbana
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Sinalização de
                            estrada
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Usinas de
                            açúcar e álcool
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Shopping Center
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Hipermercados
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Rede elétrica
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          style="margin-top: 50px"
                          src="../assets/produtos/eletroduto2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Acessórios</h3>
                      </v-col>
                      <v-col cols="12">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Tampão
                            <p>
                              O Tampão é utilizado para fechar o duto isolando-o
                              contra a entrada de líquidos, fluidos e insetos.
                            </p>
                          </li>
                          <v-col cols="3">
                            <img
                              class="imagem-produto-acessorios"
                              src="../assets/produtos/eletrodutoAcessorioTampao1.png"
                            />
                            <img
                              class="imagem-produto-acessorios"
                              src="../assets/produtos/eletrodutoAcessorioTampao2.png"
                            />
                          </v-col>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Fita de
                            Advertência
                          </li>
                          <img
                            class="imagem-produto-acessorios"
                            src="../assets/produtos/eletrodutoAcessorioFita.png"
                          />
                        </ul>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Específicações Técnicas</h3>
                        <h5>Eletroduto</h5>
                      </v-col>
                      <v-col cols="12">
                        <img
                          src="../assets/produtos/eletrodutoEspecificacoes2.png"
                        />
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Manta -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/mantaCuraConcreto1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo">Manta</span>
                    <span class="md-subhead spanSubTitulo"
                      >(para cura de concreto)</span
                    >
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Manta</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <h3 style="margin-top: -20px">para cura de concreto</h3>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Caracterizada por sua função técnica em retardar a
                        evaporação da água durante o processo de cura de
                        concreto, proporcionando a cura úmida na necessidade
                        ideal para cada perfil de obra.
                      </p>
                      <p class="paragrafo">
                        Utilizada em painéis de concreto, lajes, pisos,
                        conectados, estruturas planas.
                      </p>
                      <p class="paragrafo">
                        Devido à sua resistência, a manta de cura é um método
                        eficaz e econômico, podendo ser reutilizada de 3 a 5
                        vezes.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Painéis de
                            concreto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Lajes
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Estruturas
                            planas horizontais diversas
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Pisos
                            concretados
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          style="margin-top: 50px"
                          src="../assets/produtos/mantaCuraConcreto2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Vantagens</h3>
                      </v-col>
                      <v-col cols="12">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Diminui o
                            fissuramento do concreto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Permite
                            monitorar a hidratação do concreto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Proporciona
                            menor perda de resistência
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Geocomposto OLHAR 1LG E 2LG-->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/geocomposto1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo"
                      >Geocomposto</span
                    >
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Geocomposto</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Os geocompostos CenterGeo são compostos por uma tela de
                        PEAD (Polietileno de Alta Densidade), com função de
                        núcleo drenante, anexado termicamente a um ou dois
                        geotêxteis não-tecidos, ou ainda anexado em uma face de
                        um geotêxtil não-tecido e na outra face um filme
                        impermeabilizante.
                      </p>
                      <p class="paragrafo">
                        Engloba uma capacidade drenante superior, excedendo os
                        sistemas em brita e geotêxtil, com grandes vantagens
                        táticas, úteis, financeiras e ambientais.
                      </p>
                      <p class="paragrafo">
                        Possui baixo coeficiente de atrito e alta resistência a
                        agressões químicas.
                      </p>

                      <ul>
                        <li class="paragrafo">
                          <fa-icon :icon="['fas', 'check']" /> Geocomposto 1LG
                          <p>
                            Composto por uma tela de PED (Polietileno de Alta
                            Densidade), executando a função de núcleo drenante,
                            onde em uma de suas faces é anexado termicamente o
                            geotêxtil não-tecido, executando a função de
                            filtrar.
                          </p>
                        </li>
                        <li class="paragrafo">
                          <fa-icon :icon="['fas', 'check']" /> Geocomposto 2LG
                          <p>
                            Composto por uma tela de PED (Polietileno de Alta
                            Densidade), executando a função de núcleo drenante,
                            onde em ambas faces são anexados termicamente os
                            geotêxteis não-tecido.
                          </p>
                        </li>
                        <li class="paragrafo">
                          <fa-icon :icon="['fas', 'check']" /> Geocomposto LGT
                          <p>
                            Composto por uma tela de PED (Polietileno de Alta
                            Densidade), executando a função de núcleo drenante,
                            onde em uma de suas faces é anexado termicamente o
                            geotêxtil não-tecido, executando a função de filtrar
                            e na outra face é anexado termicamente um filme
                            impermeabilizante.
                          </p>
                        </li>
                      </ul>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Muros de arrimo
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Obras viárias
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Trincheiras
                            drenantes
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Pisos subsolo
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Estruturas
                            enterradas
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Terraços e
                            jardins
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Cortinas
                            drenantes
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Reservatórios e
                            canais
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Criar um
                            colchão entre a estrutura e o solo minimizando a
                            transferência de vibrações
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Proteger o
                            sistema de Impermeabilização
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          style="margin-top: 50px"
                          src="../assets/produtos/geocomposto2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Vantagens</h3>
                      </v-col>
                      <v-col cols="9">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Capacidade de
                            maior vazão
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Economia
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Possui elevada
                            Capacidade de fluxo
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Instalação
                            simples, rápida e limpa
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Não necessita
                            de mão de obra e ferramentas especializadas
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Permite
                            aplicação em locais com limitação de espaço
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Resistência a
                            ataque de substância química
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img src="../assets/produtos/geocomposto3.png" />
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Biomanta -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/bioManta1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo">Biomanta</span>
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Biomanta</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Fabricada industrialmente a partir de fibras vegetais de
                        coco ou palha, ou até mesmo a junção das duas fibras.
                        Sendo costurada em uma tela de polipropileno, que contém
                        alta resistência mecânica e raios UV com alta
                        durabilidade. Essa costura pode ser somente em face
                        única ou em ambas as faces. É um material biodegradável,
                        com um alto teor de nutrientes para o solo.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Taludes
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Área de
                            recuperação ambiental
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Aterros
                          </li>
                        </ul>
                      </v-col>
                      <!-- <v-col cols="3">
                        <img style="margin-top: 50px;" src="../assets/produtos/bioManta3.png">
                      </v-col> -->
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Vantagens</h3>
                      </v-col>
                      <v-col cols="9">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Controle de
                            erosão do solo
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Proteção da
                            hidrossemeadura
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Preserva a
                            umidade do solo
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Favorece a
                            germinação das sementes
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Favorece os
                            nutrientes do solo
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Favorece o
                            plantio em todos períodos, mesmo em períodos de seca
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Impede a
                            degradação do solo por efeitos do vento
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> É degradável
                            pela própria natureza
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img src="../assets/produtos/bioManta2.png" />
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Geomembrana -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/geomembranaPead1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo"
                      >Geomembrana</span
                    >
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Geomembrana</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Consiste-se em uma liga plástica, elástica e flexivel,
                        sendo o geossintéticos fabricado em PEAD (Polietileno de
                        Alta Densidade) e PEBDL (Polietileno de Baixa Densidade
                        Linear). Apresenta propriedades que garantem uma
                        excelente performance em solicitações físicas, mecânicas
                        e químicas, e que as tornam altamente resistentes às
                        suas diversas condições de aplicação. A geomembrana é
                        aplicada na construção de reservatórios de água, aterros
                        sanitários, lagos ornamentais e em estações de
                        tratamento de efluentes. São utilizadas ainda na
                        aquicultura, suinocultura, mineração e obras de
                        infraestrutura.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Lagoas de
                            contenção e de tratamento de resíduos industriais
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Lagoas para
                            piscicultura, esporte e lazer
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Piscinas e
                            praias artificiais
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Canais de
                            adução e irrigação
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Caixas d’água
                            elevadas ou enterradas
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Reservatórios
                            de lixo para Aterros Sanitário
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Reservatórios
                            para lixiviação e de rejeitos
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Armazenamento
                            de água potável e de efluentes industriais
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Reservatórios
                            de Oxidação Biológica
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Construção de
                            esterqueiras de contenção dos dejetos oriundos de
                            criação animal
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Reservatórios
                            em Estações de Tratamento de Água e Esgoto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" />
                            Impermeabilização de túneis
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Reservatório de
                            água
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          style="margin-top: 50px"
                          src="../assets/produtos/geomembranaPead2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Vantagens</h3>
                      </v-col>
                      <v-col cols="7">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Facilidade de
                            instalação
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Economia
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Ganho de espaço
                            no aterro
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Alta
                            resistência mecânica
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Resistência aos
                            raios UV
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Excelente
                            compatibilidade química
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Evita a
                            exalação do odor e propicia a captação de gás para
                            uso energético
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="5">
                        <img
                          style="margin-top: 50px"
                          src="../assets/produtos/geomembranaPead3.jpg"
                        />
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Fibra para concreto -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/fibraConcreto1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo">Fibra</span>
                    <span class="md-subhead spanSubTitulo">Para concreto</span>
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Fibra para concreto</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Fibra fabricada 100% em polipropileno, aplicada em
                        concreto e em argamassa para impossibilitar a propagação
                        e surgimento de fissuras por retrações.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Calçadas
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Pavimentação de
                            concreto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Estacionamentos
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Coberturas e
                            lajes
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Concreto
                            projetado
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Tanques de
                            concreto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Quadras
                            esportivas
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Pré-moldados
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Tubos de
                            concreto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Revestimentos e
                            argamassas
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Concretos e
                            artefatos em geral
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="3">
                        <img
                          style="margin-top: 50px"
                          src="../assets/produtos/fibraConcreto2.png"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Vantagens</h3>
                      </v-col>
                      <v-col cols="12">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Aumento da
                            resistência ao impacto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Compatível a
                            todos aditivos de concreto
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Proporciona um
                            excelente acabamento
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Modo de Uso</h3>
                      </v-col>
                      <v-col cols="12">
                        <p class="paragrafo">
                          Para cada m³ de argamassa ou concreto, usa-se 2 sacos
                          hidrossolúveis de 300g cada, de fibra de
                          polipropileno. Adicionar o pacote fechado diretamente
                          ao concreto e misturar por um período de 5 a 7
                          minutos. Para obter uma mistura homogênea, adicione os
                          pacotes em intervalos de um minuto.
                        </p>
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>

                <!-- Biorretentor (Retentores de sedimentos) -->
                <md-list-item md-expand>
                  <div>
                    <img
                      class="projectImg"
                      src="../assets/produtos/biorrolo1.png"
                    />
                  </div>
                  <div>
                    <span class="md-list-item-text spanTitulo"
                      >Biorretentor</span
                    >
                    <span class="md-subhead spanSubTitulo"
                      >(Retentores de sedimentos)</span
                    >
                  </div>
                  <md-list slot="md-expand">
                    <v-row class="mb-6" no-gutters>
                      <h2>Biorretentor</h2>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <h3 style="margin-top: -20px">
                        (Retentores de sedimentos)
                      </h3>
                    </v-row>
                    <v-row class="mb-6" no-gutters>
                      <p class="paragrafo">
                        Fabricado em forma de cilindro, flexível, composto por
                        fibras de coco reforçado por uma rede estrutural em
                        polipropileno. Estável diante dos fluxos de água, com
                        capacidade de retenção de elementos finos do solo e que
                        atua como suporte e substrato para a vegetação.
                      </p>
                      <p class="paragrafo">
                        É usado principalmente na proteção de taludes e cursos
                        d’água, para o controle de erosão como elemento de
                        contenção, como filtro de sedimentos ou como barreira
                        para reduzir a velocidade das águas de escoamento.
                        Também serve para a revegetação, aplicado em
                        hidrossemeaduras e como suporte e substrato para a
                        vegetação na recuperação de áreas degradadas.
                        Eventualmente, pode absorver vazamentos e óleos em
                        situações emergenciais.
                      </p>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="9">
                        <h3>Principais Aplicações</h3>
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Proteção das
                            beiras dos leitos
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Detenção e
                            retenção de sedimentos
                          </li>
                        </ul>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <h3>Vantagens</h3>
                      </v-col>
                      <v-col cols="7">
                        <ul>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Biodegradável
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Proteção de
                            base de taludes
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Desenvolvimento
                            de vegetação em condições de umidade adequada
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Permeabilidade
                            à água e capacidade de filtração de sólidos em
                            suspensão
                          </li>
                          <li class="paragrafo">
                            <fa-icon :icon="['fas', 'check']" /> Rápida e fácil
                            instalação
                          </li>
                        </ul>
                      </v-col>
                      <v-col cols="5">
                        <img src="../assets/produtos/biorrolo3.png" />
                      </v-col>
                    </v-row>
                  </md-list>
                </md-list-item>
              </md-list>
            </div>
          </div>
        </div>
      </div>
      <div class="section" style="background: black">
        <information-footer></information-footer>
      </div>
    </div>
  </div>
</template>

<script>
import InformationFooter from "../components/InformationFooter";

export default {
  components: { InformationFooter },
  bodyClass: "profile-page",
  data() {
    return {};
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/home/fundo.png"),
    },
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.projectImg {
  width: 200px;
  padding: 10px;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.md-card .md-card-header {
  margin: -20px 20px 15px;
  border-radius: 3px;
  padding: 20px 0;
  box-shadow: unset;
  background-color: transparent;
}

.content {
  justify-content: flex-end;
}

.paragrafo {
  white-space: break-spaces;
  text-align: justify;
  letter-spacing: unset;
  font-size: 1rem;
  color: #3c4858;
  line-height: 1.5em;
}

.imagem-produto-acessorios {
  height: 125px;
}

#prodTudoDrenoAcess {
  margin-top: 0px;
}

.spanTitulo {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #f7b71e;
  font-size: 20px;
  font-style: oblique;
}

.spanSubTitulo {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #f7b71e;
  font-style: oblique;
}

li {
  margin-bottom: 10px;
}

#prodEletroDutoTam {
  margin-top: 28px;
}

#prodEletroDutoFita {
  margin-top: 5px;
}
</style>
